import { TimelineLite } from 'gsap';
import { DrawerBase } from 'bog-arcade-core-ui/core/DrawerBase';

import { mobileConfig } from '../../../core/applicationConfig';
import { resourceHelper } from '../../../core/resourceHelper';
import { sharedSourceNames } from '../../../core/sourceNames';
import {
  amountTextStyle,
  congratulationsButtonStyle,
  congratulationsTitleStyle,
} from '../../../core/textStyles';
import { TOTAL_WIN_STATE } from '../../../stateManagment';
import { popupService } from '../../../services/helperServices/PopupService';
import { handlePointerout, handlePointerover } from '../events';
import { translationKeys } from '../../../core/translation/translation';
import { getAmount } from '../../../core/helpers/getAmount';
import { soundService } from '../../../services/helperServices/SoundService';


export class BaseCongratulationPopup extends DrawerBase {
  getPopup(
    {
      scale = 1,
      parentWidth = mobileConfig.width,
      parentHeight = mobileConfig.height,
      mistakeY = 0,
    } = {},
  ) {
    const parentContainer = this.createContainer('baseContainer');
    const container = this.createContainer('congratulationPopup');
    const mainButtonTexture = resourceHelper.get(sharedSourceNames.continueButtonActive);
    const activeButtonTexture = resourceHelper.get(sharedSourceNames.continueButtonNormal);
    const lightEffect = this.createSpine(resourceHelper.get(sharedSourceNames.purplePopupLightSpine));
    const congratulationsPopup = this.createSprite(resourceHelper.get(sharedSourceNames.congratulationsPopup));

    const continueButton = this.createSprite(mainButtonTexture);

    const congratulationText = this.createText(translationKeys.congratulations, {
      ...congratulationsTitleStyle,
      fontSize: 55,
    });

    const youHaveWonText = this.createText(translationKeys.youHaveWon, {
      ...congratulationsTitleStyle,
      fontSize: 50,
    });

    const continueText = this.createText(translationKeys.pressToContinue, {
      ...congratulationsButtonStyle,
      fontSize: 46,
    });
    const winAmount = this.createText('', {
      ...amountTextStyle,
      fontSize: 115,
    });

    this.__setupTexture(winAmount, scale * .55);
    container.addChild(winAmount);

    const rect = this.createGraphics()
      .beginFill(0x000000)
      .drawRect(0, 0, parentWidth, parentHeight)
      .endFill();
    rect.alpha = .7;

    lightEffect.scale.set(.55 * scale);
    lightEffect.state.setAnimation(0, 'animation', true);

    this.registerPointerover(continueButton, (event) => handlePointerover(event, continueButton, activeButtonTexture));
    this.registerPointerout(continueButton, (event) => handlePointerout(event, continueButton, mainButtonTexture));

    this.registerClick(continueButton, () => {
      soundService.playSingleClick();
      popupService.closeCongratulationsPopup();
    });

    this.registerClick(rect, () => {
      soundService.playSingleClick();
      popupService.closeCongratulationsPopup();
    });

    this.setupButtonMode(continueButton, { interactive: true, buttonMode: true });
    this.setupButtonMode(rect, { interactive: true, buttonMode: true });

    const textureList = [
      continueText,
      congratulationText,
      youHaveWonText,
      congratulationsPopup,
      continueButton,
      winAmount,
    ];

    textureList.forEach((texture) => {
      this.__setupTexture(texture, scale * .55);
    });

    const halfHeight = parentHeight / 2;
    const halfWidth = parentWidth / 2;

    this.setPosition(container, { x: halfWidth, y: halfHeight + mistakeY });
    this.setPosition(winAmount, { y: scale * 60 });
    this.setPosition(continueText, { y: 175 * scale });
    this.setPosition(congratulationText, { y: scale * -25 });
    this.setPosition(youHaveWonText, { y: 13 });
    this.setPosition(continueButton, { y: 175 * scale });

    container.addChild(
      lightEffect,
      congratulationsPopup,
      continueButton,
      congratulationText,
      youHaveWonText,
      continueText,
      winAmount,
    );

    this.addSubscriber(TOTAL_WIN_STATE.subscribe(() => {
      winAmount.text = getAmount(TOTAL_WIN_STATE.getValue());
    }, true));

    parentContainer.addChild(rect, container);

    this.addSubscriber(popupService.subscribeCongratulationsPopup(state => {
      parentContainer.visible = state;
      container.scale.set(0);
      new TimelineLite().to(container, { duration: .5, pixi: { scale: 1 } });
    }));

    return parentContainer;
  }

  __setupTexture(texture, scale) {
    texture.anchor.set(.5);
    texture.scale.set(scale);
  }
}
